<template>
  <div class="page profile">
    <h1>
      Profiel
      <button class="cancel" @click="resetProfile"
              title="Wijzigingen ongedaan maken">
        <fa-icon icon="history"></fa-icon>
      </button>
      <button class="save" @click="saveProfile"
              title="Opslaan">
        <fa-icon icon="save"></fa-icon>
      </button>
    </h1>
    <div class="page__content">
      <div class="form" v-if="profile">
        <div class="form__column">
          <h2>Personalia</h2>
          <div class="form__field">
            <label>Naam</label><input type="text" class="input"
                                      :class="{'input--edited':profile.NAAM!==copyProfile.NAAM}"
                                      v-model="profile.NAAM" readonly>
          </div>
          <div class="form__field">
            <label>Email</label><input type="text" class="input"
                                       :class="{'input--edited':profile.EMAIL!==copyProfile.EMAIL}"
                                       v-model="profile.EMAIL">
          </div>
          <div class="form__field">
            <label>GSM</label><input type="text" class="input" :class="{'input--edited':profile.GSM!==copyProfile.GSM}"
                                     v-model="profile.GSM">
          </div>
          <div class="form__field">
            <label>Taal</label>
            <select class="select" :class="{'select--edited':profile.TAAL!==copyProfile.TAAL}"
                    v-model="profile.TAAL">
              <option value="NL">NL</option>
              <option value="FR">FR</option>
              <option value="EN">EN</option>
            </select>
          </div>
        </div>
        <div class="form__column" v-if="isOA">
          <h2>Bedrijf</h2>
          <div class="form__field">
            <label>Naam Bedrijf</label><input type="text" class="input"
                                              :class="{'input--edited':profile.NAAMBEDRIJF!==copyProfile.NAAMBEDRIJF}"
                                              v-model="profile.NAAMBEDRIJF">
          </div>
          <div class="form__field">
            <label>Contactpersoon</label><input type="text" class="input"
                                                :class="{'input--edited':profile.NAAMCONTACTPERSOON!==copyProfile.NAAMCONTACTPERSOON}"
                                                v-model="profile.NAAMCONTACTPERSOON">
          </div>
          <div class="form__field">
            <label>Tel.</label><input type="text" class="input"
                                      :class="{'input--edited':profile.TELCONTACTPERSOON!==copyProfile.TELCONTACTPERSOON}"
                                      v-model="profile.TELCONTACTPERSOON">
          </div>
          <div class="form__field">
            <label>BTW nr.</label><input type="text" class="input"
                                         :class="{'input--edited':profile.BTWNR!==copyProfile.BTWNR}"
                                         v-model="profile.BTWNR">
          </div>
          <div class="form__field">
            <label>IBAN</label><input type="text" class="input"
                                      :class="{'input--edited':profile.IBAN!==copyProfile.IBAN}"
                                      v-model="profile.IBAN">
          </div>
          <div class="form__field">
            <label>BIC</label><input type="text" class="input" :class="{'input--edited':profile.BIC!==copyProfile.BIC}"
                                     v-model="profile.BIC">
          </div>
        </div>
        <div class="form__column">
          <h2>Adres</h2>
          <div class="form__field">
            <label>Zoek adres</label>
            <input ref="autocomplete"
                   class="input input--address"
                   type="text"/>
          </div>
          <div class="form__field">
            <label>Straat</label><input type="text" class="input" readonly
                                        :class="{'input--edited':profile.GOOGLESTREET!==copyProfile.GOOGLESTREET}"
                                        v-model="profile.GOOGLESTREET">
          </div>
          <div class="form__field">
            <label>Nr</label><input type="text" class="input" readonly
                                    :class="{'input--edited':profile.GOOGLEHOUSENR!==copyProfile.GOOGLEHOUSENR}"
                                    v-model="profile.GOOGLEHOUSENR">
          </div>
          <div class="form__field">
            <label>Postcode</label><input type="text" class="input" readonly
                                          :class="{'input--edited':profile.POSTNR!==copyProfile.POSTNR}"
                                          v-model="profile.POSTNR">
          </div>
          <div class="form__field">
            <label>Stad</label><input type="text" class="input" readonly
                                      :class="{'input--edited':profile.GEMEENTE!==copyProfile.GEMEENTE}"
                                      v-model="profile.GEMEENTE">
          </div>
        </div>
        <div class="form__column">
          <h2>Identificatie</h2>
          <div class="form__field">
            <label>Vervaldag Medisch attest</label>
            <date-picker id="datum"
                         :class="{'edited':profile.VERVALDAGMEDISCHATTEST!==copyProfile.VERVALDAGMEDISCHATTEST}"
                         v-model="profile.VERVALDAGMEDISCHATTEST" type="date" :clearable="false" format="DD/MM/YYYY"
                         value-type="DD/MM/YYYY"></date-picker>
          </div>
          <div class="form__field">
            <label>Rijbewijs</label>
            <select class="select" :class="{'select--edited':profile.CATRIJBEWIJS!==copyProfile.CATRIJBEWIJS}"
                    v-model="profile.CATRIJBEWIJS">
              <option v-for="item in licences" :value="item" :key="`licence--${item}`">{{ item }}</option>
            </select>
          </div>
          <div class="form__field">
            <label>P. waardekaart</label>
            <input type="text" class="input"
                   :class="{'input--edited':profile.PARKINGWAARDEKAART!==copyProfile.PARKINGWAARDEKAART}"
                   v-model="profile.PARKINGWAARDEKAART">
          </div>
          <div class="form__field">
            <label>P. abonnement</label>
            <input type="text" class="input"
                   :class="{'input--edited':profile.PARKINGABONNEMENT!==copyProfile.PARKINGABONNEMENT}"
                   v-model="profile.PARKINGABONNEMENT">
          </div>
          <div class="form__field">
            <label>Kinderstoelen</label>
            <input type="number" class="input input--number"
                   :class="{'input--edited':profile.KINDERSTOELEN!==copyProfile.KINDERSTOELEN}"
                   v-model="profile.KINDERSTOELEN">
          </div>
          <div class="form__field">
            <label for="tablet">Tablet HES</label>
            <input type="checkbox" id="tablet" :true-value=1
                   :false-value=0 class="checkbox"
                   :class="{'checkbox--edited':profile.TABLETHES!==copyProfile.TABLETHES}"
                   v-model="profile.TABLETHES">
          </div>
          <div class="form__field">
            <label for="mm">MAX-mobiel</label>
            <input type="checkbox" id="mm" :true-value=1
                   :false-value=0 class="checkbox"
                   :class="{'checkbox--edited':profile.MAXMOBIEL!==copyProfile.MAXMOBIEL}" v-model="profile.MAXMOBIEL">
          </div>
          <div class="form__field">
            <label for="jans">Janssen-pas</label>
            <input type="checkbox" id="jans" :true-value=1
                   :false-value=0 class="checkbox"
                   :class="{'checkbox--edited':profile.JANSSENPAS!==copyProfile.JANSSENPAS}"
                   v-model="profile.JANSSENPAS">
          </div>
          <div class="form__field">
            <label for="rook">Roker</label>
            <input type="checkbox" id="rook" :true-value=1
                   :false-value=0 class="checkbox" :class="{'checkbox--edited':profile.ROKER!==copyProfile.ROKER}"
                   v-model="profile.ROKER">
          </div>
        </div>
      </div>
      <Loader v-else></Loader>
      <div class="page__controls">
        <router-link class="button page__controls__button" to="/feedback">Mijn feedback</router-link>
        <router-link class="button page__controls__button" to="/behaviour" v-if="company === 1">Mijn rijgedrag
        </router-link>
        <router-link class="button page__controls__button" to="/documents" v-if="company === 1">Mijn documenten
        </router-link>
        <router-link class="button page__controls__button" to="/documents" v-if="company !== 88">Mijn contracten
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileService from "@/services/profile";
import DatePicker from "vue2-datepicker";
import Loader from "@/components/Loader";
import {ObjectMixin} from "@/mixins/ObjectMixin";

export default {
  name: "Profile",
  components: {DatePicker, Loader},
  data() {
    return {
      autocomplete: null,
      addressComponentForm: {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        country: 'long_name',
        postal_code: 'short_name'
      },
      user: this.$store.state.auth.user,
      mapsKey: process.env.VUE_APP_GOOGLE_MAPS,
      profile: null,
      copyProfile: null,
      licences: ['B', 'C', 'D', 'BE', 'CE', 'DE']
    }
  },
  created() {
    this.fetchProfile();
  },

  computed: {
    isOA() {
      return parseInt(this.user.BEDRIJF) === 8;
    },
    company() {
      return parseInt(this.user.BEDRIJF) === 9 ? parseInt(this.user.BEDRIJFPORTAAL) : parseInt(this.user.BEDRIJF);
    }
  },

  watch: {
    'profile.TAAL': {
      handler() {
        if (this.profile.TAAL) {
          this.$i18n.locale = this.profile.TAAL.toLowerCase();
        }
      }
    }
  },

  methods: {
    initGoogle() {
      if (this.autocomplete) {
        return;
      }
      this.$nextTick(() => {
        this.autocomplete = new google.maps.places.Autocomplete(this.$refs.autocomplete, {types: ['geocode']});
        this.autocomplete.setFields(['address_components', 'geometry']);
        this.autocomplete.addListener('place_changed', this.fillAddress);
      });
    },
    fetchProfile() {
      ProfileService.getProfile(this.user.PERS_ID).then(res => {
        this.profile = res.data;
        this.copyProfile = JSON.parse(JSON.stringify(this.profile));
        this.initGoogle();
      });
    },

    resetProfile() {
      this.profile = JSON.parse(JSON.stringify(this.copyProfile));
    },

    saveProfile() {
      const data = {
        id: this.user.PERS_ID,
        email: this.profile.EMAIL,
        taal: this.profile.TAAL,
        naam: this.profile.NAAM,
        naamcontactpersoon: this.profile.NAAMCONTACTPERSOON,
        telcontactpersoon: this.profile.TELCONTACTPERSOON,
        route: this.profile.GOOGLESTREET,
        street_number: this.profile.GOOGLEHOUSENR,
        postal_code: this.profile.POSTNR,
        locality: this.profile.GEMEENTE,
        tel: this.profile.GSM,
        btwnr: this.profile.BTWNR,
        vervaldagmedischattest: ObjectMixin.formatDateSql(this.profile.VERVALDAGMEDISCHATTEST),
        catrijbewijs: this.profile.CATRIJBEWIJS,
        parkingwaardekaart: this.profile.PARKINGWAARDEKAART,
        parkingabonnement: this.profile.PARKINGABONNEMENT,
        kinderstoelen: this.profile.KINDERSTOELEN,
        naambedrijf: this.profile.NAAMBEDRIJF,
        bic: this.profile.BIC,
        iban: this.profile.IBAN,
        tablethes: this.profile.TABLETHES,
        janssenpas: this.profile.JANSSENPAS,
        maxmobiel: this.profile.MAXMOBIEL,
        roker: this.profile.ROKER
      }
      ProfileService.saveProfile(data)
        .then(() => {
          this.fetchProfile();
        });
    },

    fillAddress() {
      this.$refs.autocomplete.value = "";
      const address = {};
      let place = this.autocomplete.getPlace();
      address.lat = place.geometry.location.lat();
      address.lon = place.geometry.location.lng();
      for (let i = 0; i < place.address_components.length; i++) {
        let addressType = place.address_components[i].types[0];
        if (this.addressComponentForm[addressType]) {
          let val = place.address_components[i][this.addressComponentForm[addressType]];
          address[addressType] = val;
        }
      }
      this.profile.STRAAT = address.route;
      this.profile.GOOGLESTREET = address.route;
      this.profile.GOOGLEHOUSENR = address.street_number;
      this.profile.POSTNR = address.postal_code;
      this.profile.GEMEENTE = address.locality;
      this.profile.LAT = address.lat;
      this.profile.LON = address.lon;
    }
  }
}
</script>

